module.exports = "<input class=\"sb-document-upload-input\" type=\"file\" style=\"display: none\" accept=\"{{vm.replaceTarget.extension}}\" />";


//////////////////
// WEBPACK FOOTER
// ./src/sharebase-app/components/documentReplaceHandler/documentReplaceHandler.template.html
// module id = 1185
// module chunks = 0